import IsAxiosError from 'components/common/IsAxiosError';
import Loading from 'components/common/Loading';
import HubertCombobox from 'components/HubertUI/HubertCombobox';
import HubertPopover from 'components/HubertUI/HubertPopover';
// import { HubertButton } from 'components/HubertUI/HubertButton';
import type { ComponentProps } from 'react';
import { useEffect, useState } from 'react';
import { Info } from 'lucide-react';
import { useGetSmartAcksQuery } from 'rtk/query/apis/misc';
import type { TSelectBase } from 'types/general.types';

interface Props extends ComponentProps<'div'> {
  isMulti?: boolean;
  value?: string | string[];
  onValueChange?: (value: string | string[]) => void;
  disabled?: boolean;
}

/**
 * This component refers to smart acknowledgements
 * @param
 * @returns
 */
const SmartAckCombobox = ({ isMulti = false, onValueChange, value, disabled = false, ...props }: Props) => {
  const { data, isLoading, isFetching, isError, error } = useGetSmartAcksQuery();

  const [items, setItems] = useState<TSelectBase[]>([]);

  useEffect(() => {
    console.log('SmartAckCombobox data', data);
    if (data?.smartAcks) {
      const sortedItems = [...data.smartAcks].sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }),
      );
      setItems(
        sortedItems.map((x) => ({
          label: x.name,
          value: x.id,
          description: x.description,
        })),
      );
    }
  }, [data?.smartAcks, value]);

  if (isLoading || isFetching) {
    return <Loading label="smart acknowledgements" />;
  }

  if (isError) {
    return <IsAxiosError error={error} />;
  }

  if (!data) {
    return null;
  }

  return (
    <div {...props} className="flex items-center gap-2">
      <HubertCombobox
        itemName="smart acknowledgements"
        isMulti={isMulti}
        items={items}
        onValueChange={onValueChange}
        value={value}
        disabled={disabled}
      />
      <HubertPopover>
        <HubertPopover.Trigger>
          <Info className="h-4 w-4 cursor-pointer text-gray-500 hover:text-gray-700" />
        </HubertPopover.Trigger>
        <HubertPopover.Content className="max-w-[400px] p-4">
          <div className="space-y-3">
            <h3 className="text-sm font-semibold">Smart Acknowledgements</h3>
            <div className="max-h-[300px] space-y-2 overflow-y-auto">
              {items.map((item) => (
                <div key={item.value} className="border-b border-gray-200 pb-2 last:border-b-0">
                  <div className="text-sm font-medium">{item.label}</div>
                  {item.description && <div className="mt-1 text-xs text-gray-600">{item.description}</div>}
                </div>
              ))}
            </div>
          </div>
        </HubertPopover.Content>
      </HubertPopover>
    </div>
  );
};

export default SmartAckCombobox;
